import './Button.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { faPlus, faMinus } from '@fortawesome/free-solid-svg-icons';

export default function Button(props){
    return(
        <button onClick={ props.handleOnClick }
        className={
            `button button__${props.color}
            ${props.fullWidth ? 'button__full-width' : '' } `
        }>
            { props.children }
        </button>
    )
}

function PlusMinusButton(props){

    return(
        <div className='pmbutton__containter'>
            <div className={`pmbutton__content ${props.small ? 'pmbutton__content-small' : ''}`}>
                <button className='pmbutton__minus' onClick={ props.handleOnClickMinus } ><FontAwesomeIcon icon={ faMinus} size='2x' /></button>
                <div>
                    <h3> { props.counter } </h3>
                </div>
                <button className='pmbutton__plus' onClick={ props.handleOnClickPlus }><FontAwesomeIcon icon={ faPlus } size='2x' /></button>
            </div>
        </div>
    )
}

export { PlusMinusButton };